import { coreService } from 'src/service/core-service'
import { queryKeys } from 'src/util/query-keys'
import { toasterUtil } from 'src/util/toaster-util'
import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'

export const useResetSuggestedSeriesFlow = (): UseMutationResult<void, Error, void> => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, void>({
    mutationFn: () => coreService.resetSuggestedSeriesFlow(),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.suggestedSeries())
    },
    onError: () => {
      toasterUtil.error('Failed to reset the series flow. Please try again.')
    },
  })
}
